module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-200.c3cce394.svg";